export default __webpack_public_path__ + "static/media/963.f78ba922.png";